import React from "react";
import { alpha, Button, Paper, Stack, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

interface Props {
  onClick: () => void;
}

export const RemoveIntegrationCard: React.FC<Props> = ({ onClick }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 3,
      border: "1px solid",
      borderColor: alpha("#ef4444", 0.2),
      bgcolor: alpha("#ef4444", 0.02),
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        borderColor: alpha("#ef4444", 0.5),
        boxShadow: `0 4px 12px ${alpha("#ef4444", 0.12)}`,
        transform: "translateY(-2px)",
      },
    }}
    onClick={onClick}
  >
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <DeleteForeverIcon sx={{ color: "error.main" }} />
        <Typography variant="subtitle1" fontWeight={700}>
          Remove Integration
        </Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        Remove your current bodycam vendor connection. You can reconnect to the same or a different vendor afterward.
      </Typography>
      <Button
        variant="outlined"
        color="error"
        onClick={onClick}
        sx={{
          alignSelf: "flex-start",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: `0 2px 8px ${alpha("#ef4444", 0.2)}`,
          },
        }}
      >
        Remove Connection
      </Button>
    </Stack>
  </Paper>
);
